import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from './plugins/axios'
import Vant from 'vant/es/'
import userSession from './comm/session'
import 'vant/lib/index.css'
const app = createApp(App)
app.use(userSession)
app.use(router).use(axios).use(Vant)
app.mount('#app')